import cloneDeep from 'lodash/cloneDeep';
import { decorateObjectWithProxy } from '@goodt-common/utils';
import { BaseEntity } from './BaseEntity';

export class SimpleEntity extends BaseEntity {
    constructor(...args) {
        super(...args);
        return decorateObjectWithProxy(this, this._props);
    }

    toJSON() {
        return cloneDeep(this._props);
    }

    toString() {
        return JSON.stringify(this.toJSON());
    }
}
